import { gql } from "@apollo/client";

/**
 * Expensive context "size" fields. Keep separate from selection/mode queries.
 */
export const FETCH_CONTEXT_SIZES_FOR_CHAT = gql`
    query ContextSizesForChat($chatId: ID!) {
        contextForChat(chatId: $chatId) {
            id
            sizeInPages
            totalAllowedPages
            sizeInTokens
        }
    }
`;


